<template>
  <div class="text-center mt-3">
    <router-link
      v-for="link in links"
      :key="link.hash"
      :to="{ name: 'dashboard', hash: link.hash }"
      class="mx-3"
    >
      {{ link.label }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: "DashboardSectionLinks",
  data() {
    return {
      links: [
        { label: 'Tracked Match IDs', hash: '#tracked-match-ids' },
        { label: 'Bookie Match Betability', hash: '#bookie-match-betability' },
        { label: 'Sportradar Tracked URLs', hash: '#sportradar-tracked-urls' },
        { label: 'Social Media Profiles', hash: '#social-media-profiles' },
      ],
    };
  },
};
</script>
